// @flow
import React, { Component } from 'react';
import { Button, Icon, Label } from 'semantic-ui-react';
import { assign, drop, first } from 'lodash';

export default class FloatingActionsHover extends Component<
    {
        options: Array<{ color?: string, description?: string, icon: string, onClick?: any => any }>
    },
    { showOptions: boolean }
> {
    state = { showOptions: false };
    render() {
        const showOptions = this.state.showOptions || this.props.options.length === 1;
        const options = drop(this.props.options, 1).map((el, index) => {
            const offset = showOptions ? index * 4 + 5.5 : 1;
            return (
                <FloatingButton
                    className="ani-bottom"
                    color={el.color}
                    description={el.description}
                    icon={el.icon}
                    key={`float-${index}`}
                    onClick={el.onClick}
                    style={{ bottom: `${offset}rem`, right: '.7rem' }}
                />
            );
        }, this);
        const mainOption = first(this.props.options);

        return (
            <div
                onMouseLeave={() => this.setState({ showOptions: false })}
                style={{
                    bottom: '1rem',
                    height: showOptions ? `${5 + options.length * 3}rem` : '5rem',
                    position: 'fixed',
                    right: '19rem',
                    width: '5.5rem',
                    zIndex: 100
                }}
            >
                {options}
                <FloatingButton
                    onClick={mainOption.onClick}
                    onMouseEnter={() => this.setState({ showOptions: true })}
                    size="massive"
                    style={{ position: 'absolute', bottom: 0, right: 0 }}
                    icon={showOptions ? mainOption.icon : 'plus'}
                />
            </div>
        );
    }
}

function FloatingButton(props: {
    as?: React$Element<*>,
    basic?: boolean,
    className?: string,
    color?: string,
    description?: string,
    icon: string,
    onClick: (SyntheticEvent<*>) => void,
    onMouseEnter?: (SyntheticEvent<*>) => void,
    onMouseLeave?: (SyntheticEvent<*>) => void,
    size?: string,
    style?: Object
}) {
    return [
        <Button
            basic={props.basic}
            circular
            className={props.className}
            color={props.color}
            content={<Icon name={props.icon} />}
            icon
            key={`btn-${props.icon}`}
            onClick={props.onClick}
            onMouseEnter={props.onMouseEnter ? props.onMouseEnter : () => null}
            onMouseLeave={props.onMouseLeave ? props.onMouseLeave : () => null}
            size={props.size}
            style={assign(props.style, { position: 'absolute' })}
        />,
        props.description ? (
            <Label
                basic
                content={props.description}
                key={`label-${props.description}`}
                pointing="right"
                style={Object.assign({}, props.style)}
            />
        ) : null
    ];
}

FloatingButton.defaultProps = {
    basic: false,
    className: '',
    color: 'blue',
    // onMouseEnter: () => null,
    // onMouseLeave: () => null,
    size: 'big'
};



// WEBPACK FOOTER //
// ./components/molecules/FloatingActionsHover.jsx